const sliderImg = [
  {
    id: "1",
    url: "https://cdn.tgdd.vn/Products/Images/42/153856/iphone-11-do-1-1-1-org.jpg",
  },
  {
    id: "2",
    url: "https://cdn.tgdd.vn/Products/Images/42/153856/iphone-11-do-3-1-org.jpg",
  },
  {
    id: "3",
    url: "https://cdn.tgdd.vn/Products/Images/42/153856/iphone-11-do-2-1-org.jpg",
  },
  {
    id: "4",
    url: "https://cdn.tgdd.vn/Products/Images/42/153856/iphone-11-1-1.jpg",
  },
  {
    id: "5",
    url: "https://cdn.tgdd.vn/Products/Images/42/153856/iphone-11-2-2.jpg",
  },
  {
    id: "6",
    url: "https://cdn.tgdd.vn/Products/Images/42/153856/iphone-11-3-1.jpg",
  },
  {
    id: "7",
    url: "https://cdn.tgdd.vn/Products/Images/42/153856/iphone-11-4-1.jpg",
  },
  {
    id: "8",
    url: "https://cdn.tgdd.vn/Products/Images/42/153856/iphone-11-5-1.jpg",
  },
  {
    id: "9",
    url: "https://cdn.tgdd.vn/Products/Images/42/153856/iphone-11-6-1.jpg",
  },
  {
    id: "10",
    url: "https://cdn.tgdd.vn/Products/Images/42/153856/iphone-11-7-1.jpg",
  },
  {
    id: "11",
    url: "https://cdn.tgdd.vn/Products/Images/42/153856/iphone-11-8-1.jpg",
  },
  {
    id: "12",
    url: "https://cdn.tgdd.vn/Products/Images/42/153856/iphone-11-9-1.jpg",
  },
  {
    id: "13",
    url: "https://cdn.tgdd.vn/Products/Images/42/153856/iphone112-3.jpg",
  },
];

export default sliderImg;
